export default __webpack_public_path__ + "static/media/1617 cutlery top.5eac5644.png";